<template>
    <div class="back-btn-progress-bar clearfix mt-5">
        <div id="results-progress-bar" class="mt-2 mb-4" style="position: relative;">
            <div class="progress-categories d-flex justify-content-between text-center" style="font-size: .7em">
                <div style="width: 33%; position: relative; left: -16%">Choose Goals</div>
                <div style="width: 33%">Create Plan</div>
                <div  style="width: 33%; position: relative; right: -16%">Take Action</div>
            </div>
            <div class="bar mt-1">
                <div class="progress" :style="{width: progress}"></div>
                <div class="marker-line" style="width: 50%"></div>
            </div>
        </div>
        <span class="go-back-btn float-left">
            <slot name="back"></slot>
        </span>
        <span class="continue-btn float-right">
            <slot name="next"></slot>
        </span>
    </div>
</template>

<script>
    export default {
        props: [
            'progress'
        ]
    }
</script>